var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpressPaycheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.914 4C16.0272 3.67937 16.028 3.3298 15.9164 3.00861C15.8049 2.68743 15.5875 2.41368 15.2999 2.23224C15.0124 2.0508 14.6717 1.97244 14.3338 2.01001C13.9958 2.04757 13.6807 2.19884 13.44 2.439L4.44 11.439C4.23014 11.6487 4.08719 11.916 4.02923 12.2069C3.97126 12.4979 4.00088 12.7995 4.11435 13.0737C4.22781 13.3478 4.42002 13.5821 4.66667 13.747C4.91331 13.9119 5.20331 13.9999 5.5 14H9.502C9.58188 14.0001 9.66057 14.0193 9.73148 14.0561C9.80239 14.0929 9.86347 14.1461 9.90959 14.2113C9.95571 14.2765 9.98554 14.3518 9.99657 14.4309C10.0076 14.5101 9.99952 14.5907 9.973 14.666L8.086 20C7.97281 20.3207 7.97199 20.6704 8.08368 20.9917C8.19536 21.313 8.41293 21.5868 8.70067 21.7681C8.98842 21.9495 9.32926 22.0277 9.66729 21.9899C10.0053 21.9521 10.3205 21.8005 10.561 21.56L19.561 12.56C19.7706 12.3502 19.9132 12.0829 19.971 11.792C20.0287 11.5011 19.9989 11.1997 19.8854 10.9257C19.7718 10.6517 19.5796 10.4176 19.333 10.2528C19.0865 10.088 18.7966 10.0001 18.5 10H14.503C14.4229 10.0001 14.344 9.98099 14.2728 9.94424C14.2017 9.90749 14.1404 9.85419 14.0941 9.78882C14.0479 9.72345 14.018 9.64793 14.007 9.56861C13.996 9.48928 14.0043 9.40848 14.031 9.333L15.914 4Z",
    stroke: "#0A0A0A",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpressPaycheck);
export default __webpack_public_path__ + "static/media/express-paycheck.3a0e696f64e01bd2354adc69f3d510cb.svg";
export { ForwardRef as ReactComponent };